export const selectEmployeeStatus = {
    bindings: {
        identifier: '@'
    },
    template: require('./select-employee-status.html'),
    controller: 'SelectEmployeeStatusController'
};
